import { render, staticRenderFns } from "./channelAndLevel.vue?vue&type=template&id=661048b2&scoped=true&"
import script from "./channelAndLevel.vue?vue&type=script&lang=js&"
export * from "./channelAndLevel.vue?vue&type=script&lang=js&"
import style0 from "./channelAndLevel.vue?vue&type=style&index=0&id=661048b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661048b2",
  null
  
)

export default component.exports